export default "__VITE_ASSET__DYkIhBYy__"